module.exports = __webpack_public_path__ + "./fonts/Simple-Line-Icons.d2285965fe34b05465047401b8595dd0.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/simple-line-icons/fonts/Simple-Line-Icons.ttf?v=2.4.0
// module id = ./node_modules/simple-line-icons/fonts/Simple-Line-Icons.ttf?v=2.4.0
// module chunks = 14